import React from 'react'
import streamLogo from '../../../assets/Images/streamlogo.png'

const Title = () => {
  return (
    <div className="HomeScreen__title">
      <img src={streamLogo} alt="stream logo" />
      <p>AR Drive-Thru Experience</p>
    </div>
  )
}

export default Title
